/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import { useRef, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import * as Yup from 'yup'
import { AiOutlineLock, AiOutlineMail } from 'react-icons/ai'

import Input from '../../../../components/Input'
import { ILogin } from '../../../../types/login'
import LogoDirecao from '../../../../assets/logos/Direção_2023_Logo_Direção.svg'
import getValidationError from '../../../../utils/getValidationErrors'
import { signInRequest, signFailure } from '../../../../store/modules/auth/actions'
import history from '../../../../services/history'
import Img from 'react-webp-image'

import { Container, Wrapper, TextCard, WrapperForm, SocialLoginWrapper } from './styles'
import { RootState } from '../../../../store/modules/rootReducer'
import GoogleLoginComponent from '../GoogleLogin'

const Login: React.FC = () => {
  const formRef = useRef<FormHandles>()
  const dispatch = useDispatch()

  const { loading } = useSelector((state: RootState) => state.auth)

  const handleSignIn = useCallback(
    async (data: ILogin) => {
      try {
        formRef.current?.setErrors({})

        const schema = Yup.object().shape({
          email: Yup.string().required('Informe o seu email'),
          password: Yup.string().min(6, 'Senha deve conter pelo menos seis caracteres'),
        })
        await schema.validate(data, {
          abortEarly: false,
        })

        dispatch(signInRequest(data))
      } catch (err) {
        dispatch(signFailure())
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationError(err)
          formRef.current?.setErrors(errors)
        }
      }
    },
    [dispatch]
  )

  function handleRedirect() {
    history.push('/forgot-password')
  }

  return (
    <Container>
      <Wrapper>
        <TextCard>
          <div className="text">
            <h1>Bem-vindo à nossa plataforma</h1>
            <h3>
              Direção Concursos representa, na atualidade, o que há de melhor na preparação em alto
              rendimento para concursos públicos no Brasil.
            </h3>
          </div>
        </TextCard>
        {/* <Img src={LogoDirecao} alt="Direção Concursos" className="logoDirecao" /> */}
        <WrapperForm>
          {/* <div className="img-direcao">
            <img src={LogoDirecao} alt="Direção Concursos" />
          </div> */}
          <Img src={LogoDirecao} alt="Direção Concursos" className="logoDirecao" />
          <Form ref={formRef} onSubmit={handleSignIn} autoComplete="false">
            <Input
              name="email"
              placeholder="E-mail"
              icon={AiOutlineMail}
              type="email"
              color="#4a4a4a"
            />
            <Input
              name="password"
              placeholder="Senha"
              icon={AiOutlineLock}
              type="password"
              isPass
              color="#4a4a4a"
            />
            <p onClick={handleRedirect} style={{ cursor: 'pointer' }}>
              Esqueceu a senha?
            </p>
            <button type="submit" disabled={loading}>
              {loading ? 'Aguarde...' : 'Entrar'}
            </button>
          </Form>
          <SocialLoginWrapper>
            <GoogleLoginComponent />
          </SocialLoginWrapper>
          {/* <p>
            Não tem conta ?<b> Registrar</b>
          </p> */}
        </WrapperForm>
      </Wrapper>
    </Container>
  )
}

export default Login
